import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    padding: 15,
    display: 'flex',
    flexDirection: 'columns',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    backgroundColor:
      theme.palette.type === 'dark' ? 'rgba(0,0,0,0)' : 'rgba(0,0,0,0)',
    borderRadius: theme.shape.borderRadius,
    cursor: 'pointer',
    overflow: 'hidden',
    transition: theme.transitions.create(['background-color'], {
      duration: theme.transitions.duration.short,
    }),
    '&:hover': {
      backgroundColor: theme.palette.divider,
    },
  },
  rootActive: {
    position: 'relative',
    padding: 15,
    display: 'flex',
    flexDirection: 'columns',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    backgroundColor:
      theme.palette.type === 'dark' ? '#fff' : theme.palette.primary.secondary,
    borderRadius: theme.shape.borderRadius,
    cursor: 'pointer',
    overflow: 'hidden',
  },
  rootPendent: {
    position: 'relative',
    padding: 15,
    display: 'flex',
    flexDirection: 'columns',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    backgroundColor: theme.palette.primary.tertiary,
    borderRadius: theme.shape.borderRadius,
    cursor: 'pointer',
    overflow: 'hidden',
    
  },
  rootIcon: {
    minWidth: 70,
    display: 'flex',
    flexDirection: 'row-reverse',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 0,
    gap: 1,
  },
  rootSplash: {
    position: 'absolute',
    right: 0,
    marginBottom: 44,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 60,
    height: 60,
    float: 'right',
    marginRight: -35,
    marginTop: -35,
    transform: 'rotate(45deg)',
  },
  rootSplash1: {
    position: 'absolute',
    right: 0,
    marginBottom: 44,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 60,
    height: 60,
    backgroundColor: theme.palette.primary.main,
    marginRight: -35,
    marginTop: -35,
    transform: 'rotate(45deg)',
  },
  rootSplash2: {
    position: 'absolute',
    right: 0,
    marginBottom: 44,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 60,
    height: 60,
    backgroundColor: theme.palette.status[3],
    float: 'right',
    marginRight: -35,
    marginTop: -35,
    transform: 'rotate(45deg)',
  },
  rootDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rootBadge: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontSize: 12,
    fontWeight: 'bold',
    backgroundColor: 'rgb(244, 106, 106)',
    borderRadius: '50%',
    width: 17,
    height: 17,
  },
}))

export default useStyles
